<template>
	<div class="modal-wrapper home-v2" :class="{ 'modal-show': show }">
		<div class="modal" v-if="show"  v-on-clickaway="hide">
			<span class="modal-close"  @click.prevent="show = false"><img src="/img/home-v2/navbar-icons/close.svg"></span>
			<div class="row">
				<div class="col-md-7">
					<div class="form-wrapper">
						<h1 class="text-left">The Ultimate Product Management eBook</h1>
						<div class="label-text text-left mb-3">
							A Complete guide to building the right product
						</div>
						<form  @submit="checkForm" >
							<div class="input-wrapper mb-3">
								<label for="name-sub">Name *</label>
								<input type="text" v-model="name" required placeholder="Enter your name" id="name-sub">
								<!-- <span class="form-icon-wrapper">
									<img src="/landing/img/user.png">
								</span> -->
								<div class="input-error" v-if="errorName" v-text="errorName"></div>
							</div>
							<div class="input-wrapper mb-3">
								<label for="email-sub">Email *</label>
								<input type="email" v-model="email" required placeholder="Enter your email" class="subscribe-email" id="email-sub">
								<!-- <span class="form-icon-wrapper" style="top: 11px;">
									<img src="/landing/img/mail.png">
								</span> -->
								<div class="input-error" v-if="errorName" v-text="errorEmail"></div>
							</div>
							<div class="input-wrapper">
								<label>Select Role</label>
								<div id="roleDropdown" class="dropdown">
									<button type="button" id="roleDropdownButton" data-flip="false" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
										{{role}}
									</button>
									<div class="dropdown-menu" aria-labelledby="roleDropdownButton">
										<div v-for="(dropdownRole, index) in roles"
											:key="index"
											class="dropdown-item"
											@click="role = dropdownRole">
											{{dropdownRole}}
										</div>
									</div>
								</div>
							</div>
							<br>
							<button type="submit" class="cta-btn-v2 sub-submit m-auto">Download eBook</button>

						</form>
					</div>
				</div>
				<div class="col-md-5 my-auto">
					<div class="ebook-img-wrapper d-none d-md-block">
						<div class="pulsating-circle"></div>
						<img src="/img/ebook/frontcover.jpg" alt="Infinity Product Management Framework Ebook" class="front-cover">
						<img src="/img/ebook/backcover.jpg" alt="Infinity Product Management Framework Ebook" class="back-cover">
					</div>
					<!-- <img src="/img/ebook/frontcover.jpg" alt="Infinity Product Management Framework Ebook" class="d-block d-md-none mx-auto" style="max-width: 70%"> -->
				</div>
			</div>
			<div class="row">
				<div class="col-12">
					<p>
						We value your privacy, and we'll never misuse private information that you entrust us with.
					</p>
				</div>
			</div>
		</div>
	</div>
</template>
<style type="text/css" scoped lang="less">
	#roleDropdown {
        width: 100%;
        #roleDropdownButton {
            // appearance: none;
            width: 100%;
            height: 50px;
            border: 1px solid #C9C9C9;
            background-color: #fff;
            border-radius: 6px;
            color: #120C32;
            padding: 15px 18px;
            font-size: 16px;
            background-image: url('/img/pricing/dropdown-arrow-down.svg');
            background-repeat: no-repeat;
            background-size: 15px 9px;
            background-position: 95% 50%;
            text-align: left;
            display: flex;
            align-items: center;
            &:focus, &:active {
                border: 1px solid #BFB6FF;
                outline: none;
            }
			@media (max-width: 768px) {
				height: 40px;
			}
        }
        .dropdown-menu {
            width: 100%;
            background: #FFFFFF;
            box-shadow: 5px 5px 15px rgba(0, 0, 0, 0.25);
            border-radius: 6px;
            padding: 7px;
			@media (max-height: 750px) {
				height: 170px;
				overflow-y: scroll;
			}
			&::-webkit-scrollbar {
				border-radius: 10px;
				width: 8px;
				background-color: #F5F5F5;
			}
			&::-webkit-scrollbar-thumb {
				border-radius: 10px;
				background-color: #62647b36;
			}
            .dropdown-item {
                cursor: pointer;
                border-radius: 6px;
                font-size: 16px;
                &:hover {
                    background-color: #F6F4FF;
                }
            }
            .dropdown-item.active {
                background-color: transparent;
                color: #5946CF;
                background-image: url('/img/pricing/ic-check.svg');
                background-repeat: no-repeat;
                background-size: 15px 9px;
                background-position: 95% 50%;
                text-align: left;
            }
        }
    }
	.ebook-img-wrapper {
		padding-top: 35px;
		padding-right: 50px;
		position: relative;
		padding-bottom: 120%;
		cursor: help;
		.back-cover {
			opacity: 0;
		}
		.back-cover, .front-cover {
			position: absolute;
			left: 0;
			top: 0;
			transition: .45s ease-in-out;
		}
		img {
			max-width: 100%;
		}
		&:hover {
			.back-cover {
				opacity: 1;
			}
			.front-cover {
				opacity: 0;
			}
		}
		.pulsating-circle {
			position: absolute;
			left: 28px;
			top: 26px;
			width: 20px;
			height: 20px;
			z-index: 2;
			&:before {
				content: '';
				position: relative;
				display: block;
				width: 300%;
				height: 300%;
				box-sizing: border-box;
				margin-left: -100%;
				margin-top: -100%;
				border-radius: 45px;
				background-color: #5946CF;
				animation: pulse-ring 1.25s cubic-bezier(0.215, 0.61, 0.355, 1) infinite;
			}

			&:after {
				content: '';
				position: absolute;
				left: 0;
				top: 0;
				display: block;
				width: 100%;
				height: 100%;
				background-color: white;
				border-radius: 15px;
				box-shadow: 0 0 8px rgba(0,0,0,.3);
				animation: pulse-dot 1.25s cubic-bezier(0.455, 0.03, 0.515, 0.955) -.4s infinite;
			}
			}

			@keyframes pulse-ring {
			0% {
				transform: scale(.33);
			}
			80%, 100% {
				opacity: 0;
			}
			}

			@keyframes pulse-dot {
			0% {
				transform: scale(.8);
			}
			50% {
				transform: scale(1);
			}
			100% {
				transform: scale(.8);
			}
			}
	}
	.modal-wrapper{
		position: fixed;
		top:0;
		left:0;
		height:100%;
		width: 100%;
		background:rgba(0,0,0,0.8);
		z-index:101;
		display:none;
		align-items:center;
		justify-content: center;

	}
	.modal-show{
		display:flex;
	}

	.modal{
		overflow: visible;
		background: #FAFBFC;
		height:auto;
		width: 1013px;
		max-width: 95%;
		background-size: 100% 100%;
		text-align:center;
		position:relative;
		display:inline !important;
		z-index:4;
		border-radius:20px;
		@media (max-width: 768px) {
			max-height: 90vh;
		}
	}
	@media (max-width: 650px) {
		.modal{
			width:90%;
		}
	}
	.form-wrapper {
		padding-left:40px;
		padding-right:40px;
		padding-top:40px;
	}
	@media (max-width: 650px) {
		.form-wrapper{
			padding-top: 20px;
			padding-left:20px;
			padding-right:20px;
		}
	}
	.modal h1{
		text-align: center;
		font-weight: 500;
		font-size: 45px;
		color: #120C32;
		font-family: 'Avenir Next Bold';
		@media (max-width: 768px) {
			font-size: 28px !important;
		}
	}
	.modal .label-text {
		font-size: 25px;
		line-height: 31px;
	}
	.modal p{
		font-size: 18px;
		line-height: 21px;
		text-align: center;
		color: #120C32;
		margin:0 auto;
		margin-bottom:	26px;
		max-width: 95%;
	}

	.modal .sub-submit{
		border: none;
		margin-bottom: 30px !important;
		@media (max-width: 768px) {
			margin-bottom: 20px !important;
		}
	}
	.modal p{
		font-weight: 500;
		font-size: 14px;
		line-height: 19px;
		text-align: center;

		color: rgba(18, 12, 50, 0.56);
	}
	.modal label{
		display: block;
		font-weight: 500;
		font-size: 18px;
		line-height: 25px;
		color: #120C32;
		text-align: left;
	}
	.modal input{
		/* border: 1px solid #FFFFFF; */
		background: #FFFFFF;
		border: 1px solid #DFDFDF;
		box-sizing: border-box;
		border-radius: 6px;
		font-size: 18px;
		line-height: 25px;
		width:100%;
		height: 50px;
		padding-left:18px;
		&:active, &:focus {
			border: 1px solid #BFB6FF;
		}
		@media (max-width: 768px) {
			height: 40px;
		}
	}
	.modal .sub-progress{
		height:100px;
		width:100%;
		background:white;
		padding: 25px 40px;
		border-radius: 20px 20px 0 0;
	}
	@media (max-width: 650px) {
		.modal .sub-progress{
			padding: 25px 20px;
		}
	}
	.modal .sub-progress-text{
		font-size: 14px;
		line-height: 19px;
		text-align: center;
		color: #000000;
		margin-bottom:11px;
	}

	.modal ::-webkit-input-placeholder {
		font-weight: 500;
		font-size: 18px;
		line-height: 25px;
		color: #989898;
	}
	.modal ::-moz-placeholder {
		font-weight: 500;
		font-size: 18px;
		line-height: 25px;
		color: #989898;
	}
	.modal :-ms-input-placeholder {
		font-weight: 500;
		font-size: 18px;
		line-height: 25px;
		color: #989898;
	}
	.modal :-moz-placeholder {
		font-weight: 500;
		font-size: 18px;
		line-height: 25px;
		color: #989898;
	}

	.modal-close{
		position: absolute;
		right: 6px;
		top: 6px;
		cursor:pointer;
		z-index: 99;
		img {
			width: 20px;
		}
	}
</style>
<script>
import { mixin as clickaway } from 'vue-clickaway';
import axios from 'axios';

export default {
//    mixins: [ VueClickaway.mixin ],
    mixins: [ clickaway ],
    data() {
        return {
            errorName: null,
            errorEmail: null,
            name: null,
            email: null,

            show: false,
            submited: false,
            copied:false,
            role: 'Role',
            roles: [
                'Chief Product Officer', 'Product Manager', 'CTO', 'Developer', 'Designer', 'Project Manager', 'Other'
            ]
        };
    },
    methods:{

        checkForm: function (e) {
            e.preventDefault();

            if (this.name && this.age) {
                return true;
            }

            this.errorName = null;
            this.errorEmail = null;

            if (!this.name) {
                this.errorName = 'Name required.';
            }
            if (this.name && this.name.length < 3) {
                this.errorName = 'Name must be at least 2 character.';
            }

            if (!this.email) {
                this.errorEmail = 'Email required.';
            }

            if(this.errorName == null && this.errorEmail == null){
                window.Intercom('boot', {
                    app_id: 'ujmidnoy',
                    email: this.email,
                    name: this.name,
                    opt_pm_ebook: true, // custom attribute ( property )
                    opt_pm_ebook_role: this.role,
                    user_id: this.email ,
                    created_at:  Math.round((new Date()).getTime() / 1000),
                });

                // push tag to google tag manager
                dataLayer.push({'event': 'OPT_pm_ebook'});

                axios.put('/api/analytics', {
                    'name': 'OPT_pm_ebook',
                });

                // add to cookie
                this.$cookies.set('ebook_submited', true ,60 * 60 * 24 * 30* 12 );
                this.$cookies.set('email', this.email ,60 * 60 * 24 * 30* 12 );
                this.$cookies.set('name', this.name ,60 * 60 * 24 * 30* 12 );
                this.submited = true;
                window.open('/downloads/Product-Management-eBook.pdf', '_blank');
                this.show = false;
            }
        },
        hide () {
            this.show = false;
        },
    },
    mounted() {
        this.submited =  this.$cookies.isKey('ebook_submited');
        document.addEventListener('mouseout', function(evt) {
            if(evt.toElement === null && evt.relatedTarget === null && !this.submited) {
                this.show = true;
                this.submited = true;
            }
        }.bind(this));
        if (window.innerWidth < 768) {
            setTimeout(function () {
                if(!this.submited) {
                    this.show = true;
                }
            }.bind(this), 5000);
        }
    },
};
</script>


// WEBPACK FOOTER //
// resources/js/frontend/components/EbookSubscribeModal.vue